import { render, staticRenderFns } from "./LocaleProvider.vue?vue&type=template&id=52ca294c&"
import script from "./LocaleProvider.vue?vue&type=script&lang=ts&"
export * from "./LocaleProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports